import { graphql } from '@/generated/gql';

export const AWARDING_CONFIGURATION_WIDGET_MUTATION = graphql(/* GraphQL */ `
  mutation AwardingConfigurationUpdate($id: UUID!, $awardingConfiguration: TsrctDemandAwardingRuleConfigurationInput!) {
    tesseract {
      demand(id: $id) {
        awardingConfiguration {
          update(data: $awardingConfiguration) {
            id
            deadlineDays
            performAutomaticAwarding
            rules {
              id
              priceDeviation
              variant
            }
          }
        }
      }
    }
  }
`);
